export default "__VITE_ASSET__Cqvn3Sl0__"